import {
  lazyPipe,
  validateApiRequest,
  validateApiResponse,
  withApiErrorCapture,
} from '@musinsa/apis-common-api-zod4';
import { executeStandardRequest } from '@musinsa/packages-http';
import { z } from 'zod';
import { privateHttpClient } from '../httpClient';
import { createApiResponseSchema } from '../utils';
import { profileApiPath } from './apiPath';

// SNS 링크 스키마 정의
const SNSLinkSchema = z
  .object({
    platform: z.string(),
    url: z.url(),
  })
  .describe('SNSLinkSchema');

// 요청 스키마 정의
const PutCuratorSnsRequestSchema = z
  .object({
    snsLinks: z.array(SNSLinkSchema).min(1).max(2),
  })
  .describe('PutCuratorSnsRequestSchema');

// 응답 데이터 스키마 정의
const PutCuratorSnsResponseDataSchema = z
  .object({
    curatorId: z.string(),
  })
  .describe('PutCuratorSnsResponseDataSchema');

// API 응답 스키마 생성
const PutCuratorSnsResponseSchema = createApiResponseSchema(PutCuratorSnsResponseDataSchema);

// 타입 추론
type PutCuratorSnsRequest = z.infer<typeof PutCuratorSnsRequestSchema>;
type PutCuratorSnsResponse = z.infer<typeof PutCuratorSnsResponseSchema>;

// API 함수 구현
export const putCuratorSns = withApiErrorCapture(
  lazyPipe(
    validateApiRequest(PutCuratorSnsRequestSchema),
    (request: PutCuratorSnsRequest) =>
      executeStandardRequest(async () =>
        privateHttpClient.put<PutCuratorSnsResponse>(profileApiPath.putCuratorSns, request),
      ),
    validateApiResponse(PutCuratorSnsResponseSchema),
  ),
);
